import React from "react"
import Card from "./Card"
import Icon from "../icon/Icon"

const CardDetails = ({ title, isOpen, className, children }) => {
  const toggleDetails = () => {
    const details = document.querySelector("details")
    if (details.hasAttribute("open")) {
      details.removeAttribute("open")
    } else {
      details.setAttribute("open", "")
    }
  }
  return (
    <Card className={`p-3 ${className}`}>
      <details {...(isOpen && { open: "open" })}>
        <summary>
          {title}
          <Icon
            icon="arrow"
            width="16"
            height="16"
            color="var(--gris)"
            onClick={toggleDetails}
          />
        </summary>
        <div>{children}</div>
      </details>
    </Card>
  )
}

export default CardDetails
